module.exports = __webpack_public_path__ + "img/feature_buy_th.815c1c8f.png";